import React, { useEffect, useState } from 'react';
import { sessionAPI } from '../../services/api';

const SessionDetailModal = ({ sessionId, open, onClose }) => {
    const [session, setSession] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!open || !sessionId) return;
        setSession(null);
        setError(null);
        setLoading(true);
        const fetchSession = async () => {
            try {
                const res = await sessionAPI.getSessionById(sessionId);
                setSession(res.data);
            } catch (err) {
                setError('Failed to fetch session details.');
            } finally {
                setLoading(false);
            }
        };
        fetchSession();
    }, [sessionId, open]);

    if (!open) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
            <div className="bg-white rounded-xl shadow-lg p-8 max-w-lg w-full relative">
                <button
                    className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-2xl font-bold"
                    onClick={onClose}
                >
                    &times;
                </button>
                <h2 className="text-2xl font-bold mb-4">Session Details</h2>
                {loading ? (
                    <div className="p-8 text-center">Loading session details...</div>
                ) : error ? (
                    <div className="p-8 text-center text-red-500">{error}</div>
                ) : !session ? (
                    <div className="p-8 text-center">No session found.</div>
                ) : (
                    <div>
                        <div className="mb-2"><strong>Date:</strong> {session.date}</div>
                        <div className="mb-2"><strong>Time:</strong> {session.startTime} - {session.endTime}</div>
                        <div className="mb-2"><strong>Status:</strong> {session.status}</div>
                        <div className="mb-2"><strong>Patient:</strong> {session.patient?.name || 'Unknown'}</div>
                        <div className="mb-2"><strong>Doctor:</strong> {session.doctor?.name || 'Unknown'}</div>
                        <div className="mb-2"><strong>Type:</strong> {session.type || 'Session'}</div>
                        <div className="mb-2"><strong>Duration:</strong> {session.duration ? `${session.duration} mins` : 'N/A'}</div>
                        {/* {session.zoomJoinUrl && (
                            <div className="mb-2">
                                <strong>Zoom Join Link:</strong> <a href={session.zoomJoinUrl} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">Join Meeting</a>
                            </div>
                        )}
                        {session.zoomStartUrl && (
                            <div className="mb-2">
                                <strong>Zoom Start Link:</strong> <a href={session.zoomStartUrl} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">Start Meeting</a>
                            </div>
                        )} */}
                    </div>
                )}
            </div>
        </div>
    );
};

export default SessionDetailModal; 